import linkSubscription from '@/client/exchanges/cacheExchange/linkSubscription';
import chat_person_preference_stream from '@/client/exchanges/cacheExchange/subscription/chat_person_preference_stream';
import current_user from '@/client/exchanges/cacheExchange/subscription/current_user';
import message_media_stream from '@/client/exchanges/cacheExchange/subscription/message_media_stream';
import message_stream from '@/client/exchanges/cacheExchange/subscription/message_stream';
import rsvp_stream from '@/client/exchanges/cacheExchange/subscription/rsvp_stream';

const Subscription = {
  badge: linkSubscription('badge'),
  badge_assignee: linkSubscription('badge_assignee'),
  badge_widget_values: linkSubscription('badge_widget_values'),
  chat: linkSubscription('chat'),
  chat_home: linkSubscription('chat_home'),
  chat_person_preference_stream,
  current_user,
  event: linkSubscription('event'),
  event_team_standing: linkSubscription('event_team_standing'),
  message_media_stream,
  message_stream,
  rsvp_stream,
  person: linkSubscription('person'),
  person_team: linkSubscription('person_team'),
  relevant_badge: linkSubscription('relevant_badge'),
  team: linkSubscription('team'),
  team_home: linkSubscription('team_home'),
  team_standing: linkSubscription('team_standing'),
};

export default Subscription;
